















import Vue, { PropType } from "vue";
import Button from "@/components/Atoms/Button/index.vue";
import { sendGaEvent } from "@/helpers/ga-helper";

export interface Props {
  id: number;
  name: string;
  isFollow: boolean;
  loading: boolean;
  gaEventCategory: string;
}
export interface Data {}
export interface Computed {
  stateClass: "followButton--followed" | "followButton--unfollowed";
  iconName: "Check" | "BellPlus";
  theme: "secondary" | "normal";
  text: "フォロー中" | "フォロー";
}
export interface Methods {}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "FollowButton",
  components: {
    Button
  },
  props: {
    id: {
      type: Number,
      default: undefined
    },
    name: {
      type: String,
      default: ""
    },
    isFollow: {
      type: Boolean as PropType<Props["isFollow"]>,
      required: true
    },
    loading: {
      type: Boolean as PropType<Props["loading"]>,
      default: false
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  computed: {
    stateClass() {
      return this.isFollow
        ? "followButton--followed"
        : "followButton--unfollowed";
    },
    iconName() {
      return this.isFollow ? "Check" : "BellPlus";
    },
    theme() {
      return this.isFollow ? "secondary" : "normal";
    },
    text() {
      return this.isFollow ? "フォロー中" : "フォロー";
    }
  },
  methods: {
    async handleClick() {
      sendGaEvent(this, {
        gaEventLabel: {
          id: this.id,
          name: this.name,
          value: !this.isFollow,
          label: !this.isFollow ? "フォロー中" : "フォロー"
        }
      });
      this.$emit("click", { isFollow: !this.isFollow });
    }
  }
});
